var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.onMobile,attrs:{"id":"app"}},[_c('router-view'),_c('b-toaster',{attrs:{"name":"b-toaster-bottom-right"}}),_c('NotificationToast',{ref:"notification"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }